import { render, staticRenderFns } from "./AiAdvertGenerationSettings.vue?vue&type=template&id=4a3573a8"
import script from "./AiAdvertGenerationSettings.vue?vue&type=script&lang=ts"
export * from "./AiAdvertGenerationSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports